/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerAddress } from './customer_address'
/**
 * Запрос на добавление юридического адреса контрагенту
 */
export type CustomerCreateAddressRequest = {
  /**
   * Источник данных (User - поля с адресом заполнил пользователь, Auto - поля с адресом заполнены без участия пользователя)
   */
  dataSource: CustomerCreateAddressRequest.dataSource
  /**
   * Юридический адрес (обязательное поле при dataSource = Auto)
   */
  legalAddress?: string
  /**
   * Юридический адрес (обязательное поле при dataSource = User)
   */
  address?: CustomerAddress
}
export namespace CustomerCreateAddressRequest {
  /**
   * Источник данных (User - поля с адресом заполнил пользователь, Auto - поля с адресом заполнены без участия пользователя)
   */
  export enum dataSource {
    AUTO = 'auto',
    USER = 'user'
  }
}
